import LinkedInAccountsTag from "common/components/LinkedInAccountsTag";
import { LeadSectionContainer } from "common/components/leads/index";

export default function LeadOf({ leadOf }: { leadOf: string[] }) {
  if (!leadOf.length) {
    return;
  }

  return (
    <LeadSectionContainer title="Can chat with" isColumn hasBorder>
      <div className="flex gap-1.5 flex-wrap">
        {leadOf.map((accountId) => (
          <LinkedInAccountsTag key={accountId} accountIds={[accountId]} />
        ))}
      </div>
    </LeadSectionContainer>
  );
}
